import { render } from "./ProblemSection.vue?vue&type=template&id=70956310"
import script from "./ProblemSection.vue?vue&type=script&lang=js"
export * from "./ProblemSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__